<template>
  <div>
    <BaseTitle
      :title="$t('content.class_type_title')"
      :yearPeriode="titleData"
      :referralcode="referral"
      :qrCode="qrCode"
      :toggleExport="toggleExport"
      :fileZip="fileZip"
    />
    <!-- <div class="d-flex justify-end align-center" v-if="user.cerdasTypeId === 2 && type === 'teacher'">
      <v-btn color="primary" class="btn-primary-custom" @click="download" :loading="loadingDownload">{{ $t('download') }}</v-btn>
      <v-divider vertical class="mr-3 ml-3" dark />
      <v-btn color="primary" class="btn-primary-custom" @click="attachToggle">
        {{ $t('content.attach_content') }}
      </v-btn>
    </div> -->
    <v-row>
      <v-col v-for="(item, index) in menus" :key="index" md="4">
        <div class="class-item" @click="gotoPage(item)">
          <svg-icon :icon="item.icon" v-if="item.icon == 'img-quiz'" width="198" height="140" />
          <svg-icon :icon="item.icon" v-if="item.icon != 'img-quiz'" width="165" height="165" />
          <strong class="class-item-title" v-if="item.icon == 'attendance'">{{ $t('menu.attendance') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'files'">{{ $t('menu.files') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'assignment'">{{ $t('menu.assignment') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'img-quiz'">{{ $t('menu.quiz') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'quiz-d'">{{ $t('content.discussion') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'syllabus'">{{ $t('content.syllabus') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'pages'">{{ $t('content.pages') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'score'">{{ $t('menu.score') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'modules'">{{ $t('content.modules') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'announcement'">{{ $t('content.announcement') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'ic-people'">{{ $t('content.people') }}</strong>
          <!-- <strong class="class-item-title" v-if="item.icon == 'ic-list-student'">{{ $t('content.list_student') }}</strong> -->
        </div>
      </v-col>
      <div class="pa-5 fixed-card" v-if="user.cerdasTypeId === 2 && type === 'teacher' && !this.$route.params.classSectionId">
        <div class="succ-content">
          <h1 class="succ-heading">{{ $t('content.class_section_add') }}!</h1>
          <div class="succ-content">{{ $t('content.class_section_add_content') }}</div>
          <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2 mt-3 ml-2" @click="dialogPopUp = true">{{
            $t('content.class_section_title')
          }}</v-btn>
        </div>
      </div>

      <!-- Dialog export import -->
      <v-dialog v-model="dialogPopUpAttach" persistent max-width="607">
        <v-card>
          <v-card-title class="headline secondary white--text">
            {{ $t('content.attack_file_zip') }}
          </v-card-title>
          <v-card-subtitle class="headline d-flex justify-center pa-5">
            <v-row>
              <v-col cols="12" md="12">
                <form-group :name="$t('form.file')" :validator="$v.formAttach.file" no-gutter>
                  <template slot-scope="{ attrs }">
                    <v-file-input
                      :label="$t('form.file')"
                      accept=".zip"
                      chips
                      show-size
                      v-bind="attrs"
                      small-chips
                      v-model="formAttach.file"
                      truncate-length="15"
                      @input="$v.formAttach.file.$touch()"
                      @blur="$v.formAttach.file.$touch()"
                    ></v-file-input>
                  </template>
                </form-group>
              </v-col>
            </v-row>
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer />
            <div class="d-flex justify-end align-center">
              <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="closeDialogAttach">{{ $t('back') }}</v-btn>
              <v-btn color="primary" class="btn-primary-custom" :loading="loadingAttach" type="submit" @click="attach">{{ $t('submit') }}</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog Class Section -->
      <v-dialog v-model="dialogPopUp" persistent max-width="800">
        <v-card>
          <v-card-title class="headline secondary white--text d-flex justify-space-between">
            <span>{{ $t('content.class_section_title') }}</span>
            <v-checkbox color="green" dense @change="checkClassSectionStatus" v-model="status">
              <template v-slot:label>
                <span class="input__label">{{ $t('content.class_section') }}</span>
              </template>
            </v-checkbox>
          </v-card-title>
          <v-card-subtitle v-if="status === true" class="pa-10">
            <v-row>
              <v-col cols="12" md="4" class="py-0">
                <form-group :name="$t('content.classroom')">
                  <template slot-scope="{ attrs }">
                    <v-text-field :value="titleData" disabled v-bind="attrs" :label="$t('content.classroom')" />
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12" md="3" class="py-0">
                <form-group :name="$t('content.number_class')" :validator="$v.formInput.numberClass">
                  <template slot-scope="{ attrs }">
                    <v-text-field
                      number
                      type="number"
                      v-model="formInput.numberClass"
                      v-bind="attrs"
                      @input="$v.formInput.numberClass.$touch()"
                      @blur="$v.formInput.numberClass.$touch()"
                      :label="$t('content.number_class')"
                    />
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12" md="3" class="py-0">
                <form-group :name="$t('form.status')" :validator="$v.formInput.status">
                  <template slot-scope="{ attrs }">
                    <v-select
                      v-model="formInput.status"
                      v-bind="attrs"
                      @input="$v.formInput.status.$touch()"
                      @blur="$v.formInput.status.$touch()"
                      :label="$t('form.status')"
                      :items="lockItems"
                    />
                  </template>
                </form-group>
              </v-col>
            </v-row>
            {{ $t('content.class_section_content') }}
            <v-row>
              <v-col cols="12" md="6" class="py-0">
                <div class="move-list">
                  <div class="move-list-title mt-3">
                    <v-text-field dense filled dark rounded hide-details :label="$t('content.teacher_list')" single-line v-model="searchTeacher">
                      <template #append>
                        <v-icon color="white">mdi-magnify</v-icon>
                      </template>
                    </v-text-field>
                  </div>
                  <div class="move-list-content">
                    <ul v-if="filterTeacher.length">
                      <li v-for="item in filterTeacher" :key="item.userId">
                        <v-checkbox color="secondary" v-model="formInput.teachers" :value="item.userId" :label="`${item.fullName}`" />
                      </li>
                    </ul>
                    <NoData v-if="!filterTeacher.length" />
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <div class="move-list">
                  <div class="move-list-title mt-3">
                    <v-text-field dense filled dark rounded hide-details :label="$t('content.student_list')" single-line v-model="searchStudent">
                      <template #append>
                        <v-icon color="white">mdi-magnify</v-icon>
                      </template>
                    </v-text-field>
                  </div>
                  <div class="move-list-content">
                    <ul v-if="filterStudent.length">
                      <li v-for="item in filterStudent" :key="item.studentId">
                        <v-checkbox color="secondary" v-model="formInput.students" :value="item.studentId" :label="`${item.fullName}`" />
                      </li>
                    </ul>
                    <NoData v-if="!filterStudent.length" />
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-subtitle>
          <v-card-subtitle v-else class="mt-10">
            <NoData />
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer />
            <div class="d-flex justify-end align-center mb-2 mr-2">
              <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="backMenu">{{ $t('back') }}</v-btn>
              <v-btn color="primary" class="btn-primary-custom" v-if="status === true" type="submit" :loading="loading" @click="submitClassSection">{{
                $t('submit')
              }}</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';
import { required } from 'vuelidate/lib/validators';
import { fileType } from '@/validators';
import moment from 'moment-timezone';

const extAllowed = ['zip'];

export default {
  name: 'MenuList',
  props: {
    type: {
      type: String
    }
  },
  components: {
    BaseTitle,
    NoData
  },
  validations() {
    return {
      formInput: {
        numberClass: { required },
        status: { required }
      },
      formAttach: {
        file: {
          required,
          fileType: fileType(extAllowed)
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      student: 'Auth/student',
      isAuthenticated: 'Auth/isAuthenticated',
      permission: 'Auth/permission',
      user: 'Auth/user',
      referalCode: 'CourseList/referalCode',
      nameCourse: 'CourseList/nameCourse'
    }),
    menus() {
      return this.items ? this.items.filter(item => this.permission?.includes(item?.id)) : [];
    },
    referral() {
      return this.referalCode;
    },
    filterStudent() {
      if (this.searchStudent) {
        return this.listStudent.filter(item => {
          return item.fullName.toLowerCase().startsWith(this.searchStudent.toLowerCase());
        });
      } else {
        return this.listStudent;
      }
    },
    filterTeacher() {
      if (this.searchTeacher) {
        return this.listTeacher.filter(item => {
          return item.fullName.toLowerCase().includes(this.searchTeacher.toLocaleLowerCase());
        });
      } else {
        return this.listTeacher;
      }
    },
    toggleExport() {
      return this.user.cerdasTypeId === 2 && this.type === 'teacher' ? true : false;
    },
    lockItems() {
      return [
        { text: this.$t('paginate.show'), value: true },
        { text: this.$t('content.hide'), value: false }
      ];
    }
  },
  data: () => ({
    items: [],
    dataClass: '',
    qrCode: '',
    dialogPopUp: false,
    dialogPopUpAttach: false,
    loading: false,
    loadingDownload: false,
    loadingAttach: false,
    titleData: '',
    searchTeacher: '',
    searchStudent: '',
    status: false,
    formInput: {
      numberClass: '',
      status: '',
      teachers: [],
      students: []
    },
    formAttach: {
      file: null,
      fileName: ''
    },
    listTeacher: [],
    listStudent: [],
    fileZip: ''
  }),
  watch: {
    student: {
      deep: true,
      handler() {
        if (this.isAuthenticated) {
          this.$router.push({ name: 'ParentClassIndex' });
        }
      }
    }
  },
  methods: {
    closeDialogAttach() {
      this.dialogPopUpAttach = false;
      this.formAttach.file = null;
      this.$v.$reset();
    },
    download() {
      if (this.canBeExported === true) {
        this.loadingDownload = true;
        const { classId, courseId } = this.$route.params;
        this.$store
          .dispatch('ExportClass/download', {
            classId,
            courseId,
            classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
          })
          .then(response => {
            let blob = new Blob([response.data], { type: 'octet/stream' });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${this.fileZip}`;
            link.click();
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally(() => (this.loadingDownload = false));
      } else {
        this.$store.dispatch('general/showErrorNotification', {
          message: `Unable to download, you have to assign one of the contents in this menu `
        });
      }
    },
    attachToggle() {
      this.dialogPopUpAttach = true;
    },
    attach() {
      this.$v.formAttach.$touch();
      if (this.$v.formAttach.$invalid) return false;

      this.loadingAttach = true;

      var fpath = this.formAttach.file.name;

      fpath = fpath.replace(/\\/g, '/');

      var fname = fpath.substring(fpath.lastIndexOf('/') + 1, fpath.lastIndexOf('.'));

      if (/^[a-zA-Z0-9|.| |_|-]*$/i.test(fname)) {
        this.formAttach.fileName = fname;
        const { classId, courseId, classSectionId } = this.$route.params;
        this.$store
          .dispatch('ExportClass/attach', { classId, courseId, classSectionId, ...this.formAttach })
          .then(({ data }) => {
            if (data.data.errorImports.length === 0) {
              this.$store.dispatch('general/showSuccessNotification', { message: data.data.message });
            } else {
              var datas = '';
              data.data.errorImports.forEach(element => {
                datas +=
                  `
              ` +
                  element.message +
                  `
              `;
              });
              this.$store.dispatch('general/showErrorNotification', { message: datas });
            }
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally(() => {
            this.loadingAttach = false;
            this.dialogPopUpAttach = false;
            this.formAttach.file = null;
            this.$v.$reset();
          });
      } else {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('content.word_upload') });
        this.loadingAttach = false;
        this.dialogPopUpAttach = false;
        this.formAttach.file = null;
        this.$v.$reset();
      }
    },
    getData() {
      if (!this.$route.params.classSectionId) {
        switch (this.type) {
          case 'teacher':
            this.items = [
              { id: 'ROLE_ATTENDANCE_VIEW', icon: 'attendance', link: { name: 'TeacherAttendanceIndex' } },
              { id: 'ROLE_FILES_VIEW', icon: 'files', link: { name: 'TeacherFile' } },
              { id: 'ROLE_ASSIGNMENT_VIEW', icon: 'assignment', link: { name: 'TeacherAssignment' } },
              { id: 'ROLE_QUIZ_VIEW', icon: 'img-quiz', link: { name: 'QuizTeacherIndexClass' } },
              { id: 'ROLE_DISCUSSION_VIEW', icon: 'quiz-d', link: { name: 'DiscussionIndexClass' } },
              { id: 'ROLE_SYLLABUS_VIEW', icon: 'syllabus', link: { name: 'SyllabusIndexClass' } },
              { id: 'ROLE_PAGES_VIEW', icon: 'pages', link: { name: 'PagesIndexClass' } },
              { id: 'ROLE_MODULE_VIEW', icon: 'modules', link: { name: 'ModulesIndexClass' } },
              { id: 'ROLE_ANNOUNCEMENT_VIEW', icon: 'announcement', link: { name: 'AnnouncementIndexClass' } }
            ];
            break;
          case 'parent':
            this.items = [
              { id: 'ROLE_ATTENDANCE_VIEW', icon: 'attendance', link: { name: 'ParentAttendance' } },
              { id: 'ROLE_SCORE_VIEW', icon: 'score', link: { name: 'ParentScore' } },
              { id: 'ROLE_ANNOUNCEMENT_VIEW', icon: 'announcement', link: { name: 'AnnouncementParentIndexClass' } }
            ];
            break;
          case 'student':
            this.items = [
              { id: 'ROLE_ATTENDANCE_VIEW', icon: 'attendance', link: { name: 'StudentAttendance' } },
              { id: 'ROLE_ASSIGNMENT_VIEW', icon: 'assignment', link: { name: 'StudentAssignment' } },
              { id: 'ROLE_SCORE_VIEW', icon: 'score', link: { name: 'StudentScore' } },
              { id: 'ROLE_FILES_VIEW', icon: 'files', link: { name: 'StudentFile' } },
              { id: 'ROLE_DISCUSSION_VIEW', icon: 'quiz-d', link: { name: 'DiscussionStudentIndexClass' } },
              { id: 'ROLE_SYLLABUS_VIEW', icon: 'syllabus', link: { name: 'SyllabusnStudentIndexClass' } },
              { id: 'ROLE_MODULE_VIEW', icon: 'modules', link: { name: 'ModulesStudentIndexClass' } },
              { id: 'ROLE_ANNOUNCEMENT_VIEW', icon: 'announcement', link: { name: 'AnnouncementStudentIndexClass' } }
            ];
            break;
          case 'school-advisor':
            this.items = [
              { id: 'ROLE_ATTENDANCE_VIEW', icon: 'attendance', link: { name: 'AdvisorAttendanceIndex' } },
              { id: 'ROLE_ASSIGNMENT_VIEW', icon: 'assignment', link: { name: 'AdvisorAssignment' } },
              { id: 'ROLE_SYLLABUS_VIEW', icon: 'syllabus', link: { name: 'SyllabusnAdvisorIndexClass' } }
            ];
            break;
        }
      } else {
        switch (this.type) {
          case 'teacher':
            this.items = [
              { id: 'ROLE_ATTENDANCE_VIEW', icon: 'attendance', link: { name: 'TeacherAttendanceSectionIndex' } },
              { id: 'ROLE_FILES_VIEW', icon: 'files', link: { name: 'TeacherSectionFile' } },
              { id: 'ROLE_ASSIGNMENT_VIEW', icon: 'assignment', link: { name: 'TeacherAssignmentSection' } },
              { id: 'ROLE_QUIZ_VIEW', icon: 'img-quiz', link: { name: 'QuizTeacherSectionIndexClass' } },
              { id: 'ROLE_DISCUSSION_VIEW', icon: 'quiz-d', link: { name: 'DiscussionSectionIndexClass' } },
              { id: 'ROLE_SYLLABUS_VIEW', icon: 'syllabus', link: { name: 'SyllabusSectionIndexClass' } },
              { id: 'ROLE_PAGES_VIEW', icon: 'pages', link: { name: 'PagesSectionIndexClass' } },
              { id: 'ROLE_MODULE_VIEW', icon: 'modules', link: { name: 'ModulesSectionIndexClass' } },
              { id: 'ROLE_ANNOUNCEMENT_VIEW', icon: 'announcement', link: { name: 'AnnouncementSectionIndexClass' } }
            ];
            break;
          case 'parent':
            this.items = [
              { id: 'ROLE_ATTENDANCE_VIEW', icon: 'attendance', link: { name: 'ParentSectionAttendance' } },
              { id: 'ROLE_SCORE_VIEW', icon: 'score', link: { name: 'ParentSectionScore' } },
              { id: 'ROLE_ANNOUNCEMENT_VIEW', icon: 'announcement', link: { name: 'AnnouncementParentSectionIndexClass' } }
            ];
            break;
          case 'student':
            this.items = [
              { id: 'ROLE_ATTENDANCE_VIEW', icon: 'attendance', link: { name: 'StudentSectionAttendance' } },
              { id: 'ROLE_ASSIGNMENT_VIEW', icon: 'assignment', link: { name: 'StudentSectionAssignment' } },
              { id: 'ROLE_SCORE_VIEW', icon: 'score', link: { name: 'StudentSectionScore' } },
              { id: 'ROLE_FILES_VIEW', icon: 'files', link: { name: 'StudentSectionFile' } },
              { id: 'ROLE_DISCUSSION_VIEW', icon: 'quiz-d', link: { name: 'DiscussionStudentSectionIndexClass' } },
              { id: 'ROLE_SYLLABUS_VIEW', icon: 'syllabus', link: { name: 'SyllabusnStudentSectionIndexClass' } },
              { id: 'ROLE_MODULE_VIEW', icon: 'modules', link: { name: 'ModulesStudentSectionIndexClass' } },
              { id: 'ROLE_ANNOUNCEMENT_VIEW', icon: 'announcement', link: { name: 'AnnouncementStudentSectionIndexClass' } }
            ];
            break;
          case 'school-advisor':
            this.items = [
              { id: 'ROLE_ATTENDANCE_VIEW', icon: 'attendance', link: { name: 'AdvisorSectionAttendanceIndex' } },
              { id: 'ROLE_ASSIGNMENT_VIEW', icon: 'assignment', link: { name: 'AdvisorSectionAssignment' } },
              { id: 'ROLE_SYLLABUS_VIEW', icon: 'syllabus', link: { name: 'SyllabusnAdvisorIndexClassSection' } }
            ];
            break;
        }
      }
    },
    getDataLite() {
      switch (this.type) {
        case 'teacher':
          this.items = [
            { id: 'ROLE_ATTENDANCE_LITE_VIEW', icon: 'attendance', link: { name: 'TeacherAttendanceIndex' } },
            { id: 'ROLE_FILES_LITE_VIEW', icon: 'files', link: { name: 'TeacherFile' } },
            { id: 'ROLE_ASSIGNMENT_LITE_VIEW', icon: 'assignment', link: { name: 'TeacherAssignment' } },
            { id: 'ROLE_QUIZ_LITE_VIEW', icon: 'img-quiz', link: { name: 'QuizTeacherIndexClass' } },
            { id: 'ROLE_DISCUSSION_LITE_VIEW', icon: 'quiz-d', link: { name: 'DiscussionIndexClass' } },
            { id: 'ROLE_SYLLABUS_LITE_VIEW', icon: 'syllabus', link: { name: 'SyllabusIndexClass' } },
            { id: 'ROLE_PAGES_LITE_VIEW', icon: 'pages', link: { name: 'PagesIndexClass' } },
            { id: 'ROLE_MODULE_LITE_VIEW', icon: 'modules', link: { name: 'ModulesIndexClass' } },
            { id: 'ROLE_ANNOUNCEMENT_LITE_VIEW', icon: 'announcement', link: { name: 'AnnouncementIndexClass' } },
            { id: 'ROLE_MODULE_LITE_VIEW', icon: 'ic-people', link: { name: 'ListTeacherIndexClass' } }
            // { id: 'ROLE_ANNOUNCEMENT_LITE_VIEW', icon: 'ic-list-student', link: { name: 'ListStudentIndexClass' } }
          ];
          break;
        case 'student':
          this.items = [
            { id: 'ROLE_ATTENDANCE_LITE_VIEW', icon: 'attendance', link: { name: 'StudentAttendance' } },
            { id: 'ROLE_ASSIGNMENT_LITE_VIEW', icon: 'assignment', link: { name: 'StudentAssignment' } },
            { id: 'ROLE_SCORE_LITE_VIEW', icon: 'score', link: { name: 'StudentScore' } },
            { id: 'ROLE_FILES_LITE_VIEW', icon: 'files', link: { name: 'StudentFile' } },
            { id: 'ROLE_DISCUSSION_LITE_VIEW', icon: 'quiz-d', link: { name: 'DiscussionStudentIndexClass' } },
            { id: 'ROLE_SYLLABUS_LITE_VIEW', icon: 'syllabus', link: { name: 'SyllabusnStudentIndexClass' } },
            { id: 'ROLE_MODULE_LITE_VIEW', icon: 'modules', link: { name: 'ModulesStudentIndexClass' } },
            { id: 'ROLE_ANNOUNCEMENT_LITE_VIEW', icon: 'announcement', link: { name: 'AnnouncementStudentIndexClass' } }
          ];
          break;
      }
    },
    getDataClass() {
      let second = moment().format('HHmmss');
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                if (this.user.cerdasTypeId === 2 && this.type === 'teacher') {
                  this.$store
                    .dispatch(`CourseSchool/fetchDetail`, this.$route.params.courseId)
                    .then(mantul => {
                      this.fileZip = `classroom_${resa.classroomName.replace(/ /g, '_')}_course_${mantul.name}_${moment().format(
                        'yyyyMMDD'
                      )}${second}.zip`;
                    })
                    .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
                }

                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                if (this.user.cerdasTypeId === 2 && this.type === 'teacher') {
                  this.$store
                    .dispatch(`CourseSchool/fetchDetail`, this.$route.params.courseId)
                    .then(mantul => {
                      this.fileZip = `classroom_${resa.classroomName.replace(/ /g, '_')}_course_${mantul.name}_${moment().format(
                        'yyyyMMDD'
                      )}${second}.zip`;
                    })
                    .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
                }

                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              if (this.user.cerdasTypeId === 2 && this.type === 'teacher') {
                this.$store
                  .dispatch(`CourseSchool/fetchDetail`, this.$route.params.courseId)
                  .then(mantul => {
                    this.fileZip = `classroom_${resa.classroomName.replace(/ /g, '_')}_course_${mantul.name}_class_section_${
                      res.numberClass
                    }_${moment().format('yyyyMMDD')}${second}.zip`;
                  })
                  .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
              }

              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    getQrCode() {
      this.$store.dispatch('Class/fetchGenerateUrl', { classId: this.$route.params.classId, courseId: this.$route.params.courseId }).then(res => {
        var url = new URL(res);
        var schoolName = url.searchParams.get('schoolName');
        var referal_code = url.searchParams.get('referal_code');
        var masterSchoolId = url.searchParams.get('masterSchoolId');
        var educationalLevel = url.searchParams.get('educationalLevel');
        var provinceId = url.searchParams.get('provinceId');
        var cityId = url.searchParams.get('cityId');
        this.qrCode = `${process.env.VUE_APP_BASE_URL_STAGING}auth/register/student?referal_code=${referal_code}&schoolName=${schoolName}&masterSchoolId=${masterSchoolId}&educationalLevel=${educationalLevel}&provinceId=${provinceId}&cityId=${cityId}`;
      });
    },
    gotoPage(item) {
      this.$router.push(item.link);
    },
    getListStudentAndTeacher() {
      this.$store.dispatch('ClassSection/listStudent', { classId: this.$route.params.classId, courseId: this.$route.params.courseId }).then(res => {
        this.listStudent = res;
      });
      this.$store.dispatch('ClassSection/listTeacher', { classId: this.$route.params.classId, courseId: this.$route.params.courseId }).then(res => {
        this.listTeacher = res;
      });
    },
    getCheckImport() {
      this.loading = true;
      this.$store
        .dispatch(`Class/checkStatusImportExport`, {
          classId: this.$route.params.classId,
          courseId: this.$route.params.courseId,
          classSectionId: this.$route.params.classSectionId
        })
        .then(data => (this.canBeExported = data.canBeExported))
        .finally(() => (this.loading = false));
    },
    submitClassSection() {
      this.$v.$touch();
      if (this.$v.formInput.$invalid) {
        return false;
      }
      this.loading = true;
      this.$store
        .dispatch(`ClassSection/createSection`, { payload: { ...this.formInput, ...this.$route.params } })
        .then(res => {
          const params = { courseId: this.$route.params.courseId };
          this.$store.dispatch(`ClassSection/updateStatus`, { status: true, classSectionId: res.data.data.classSectionId }).then(() => {});
          this.$router.push({ name: 'TeacherClassSectionList', params });
        })
        .finally(() => {
          this.dialogPopUp = false;
          this.loading = false;
        });
    },
    checkClassSection() {
      const params = { classId: this.$route.params.classId, courseId: this.$route.params.courseId };
      let url;
      switch (this.type) {
        case 'teacher':
          url = 'TeacherClassSectionList';
          return; // prevent change page when role is teacher
        case 'parent':
          url = 'ParentClassSectionList';
          break;
        case 'student':
          url = 'StudentClassSectionList';
          break;
        case 'school-advisor':
          url = 'AdvisorSectionMenuSectionList';
          break;
      }
      this.$store.dispatch(`ClassSection/getListClassSection`, { ...params }).then(res => {
        if (res.classSection === true) {
          localStorage.setItem('backMenu', true);
          const params = { courseId: this.$route.params.courseId };
          this.status = res.classSection;
          this.$router.push({ name: `${url}`, params });
        }
      });
    },
    checkClassSectionStatus() {
      const params = { classId: this.$route.params.classId, courseId: this.$route.params.courseId };
      this.$store.dispatch(`ClassSection/updateStatusClassroomCourse`, { status: this.status, ...params }).then(() => {
        this.checkClassSection();
      });
    },
    backMenu() {
      this.dialogPopUp = false;
    }
  },
  created() {
    this.getCheckImport();
    if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
      this.getData();
      if (this.type === 'teacher') {
        this.getListStudentAndTeacher();
      }
    } else {
      this.getDataLite();
      this.getQrCode();
    }
    if (!this.$route.params.classSectionId) {
      this.checkClassSection();
      // this.getStatusClassSection();
    }

    this.getDataClass();
  }
};
</script>

<style lang="scss" scoped>
.class-item {
  display: flex;
  border-radius: 8px;
  box-shadow: 0 7px 16px 0 rgba(0, 0, 0, 0.13);
  background: #fff;
  padding: 10px;
  cursor: pointer;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 240px;

  &-title {
    color: #6d6d6d;
    display: block;
  }

  &:hover {
    background: #f8f8f8;
  }
}
.fixed-card {
  background-color: #ffffff;
  border: 1px solid #56a6dc;
  border-radius: 8px;
  margin-left: 10px;
  margin-right: 10px;
  box-shadow: 0 7px 16px 0 rgba(0, 0, 0, 0.13);
  width: 100%;
}
.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    font-size: 12px;
  }

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }

  &-heading {
    color: #6d6d6d;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 16px;
  }
}
.move-list {
  &-title {
    background: #00bf63;
    color: #fff;
    font-family: Montserrat;
    font-weight: 800;
    border-radius: 8px 8px 0 0;
    padding: 10px;
    width: 100%;
  }

  &-content {
    border: 1px solid #d8d8d8;
    border-radius: 0 0 8px 8px;
    padding: 10px;
    overflow: scroll;
    overflow-x: hidden;
    width: 100%;
    height: 18em;
    line-height: 2em;

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d8d8d8;
        padding: 10px 15px;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
.input__label {
  color: white;
}
</style>
